var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2015 6.6665H20.3574V9.5093H25.2015V6.6665Z",
    fill: "#40AB5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2015 10.6079H20.3574V13.4507H25.2015V10.6079Z",
    fill: "url(#paint0_linear_2341_2149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2015 14.5493H20.3574V17.3922H25.2015V14.5493Z",
    fill: "url(#paint1_linear_2341_2149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6429 18.4907H2.79883V21.3335H7.6429V18.4907Z",
    fill: "url(#paint2_linear_2341_2149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4915 18.4907H8.64746V21.3335H13.4915V18.4907Z",
    fill: "url(#paint3_linear_2341_2149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3519 18.4907H14.5078V21.3335H19.3519V18.4907Z",
    fill: "url(#paint4_linear_2341_2149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2015 18.4907H20.3574V21.3335H25.2015V18.4907Z",
    fill: "url(#paint5_linear_2341_2149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3519 14.5493H14.5078V17.3922H19.3519V14.5493Z",
    fill: "url(#paint6_linear_2341_2149)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4915 14.5493H8.64746V17.3922H13.4915V14.5493Z",
    fill: "url(#paint7_linear_2341_2149)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4915 10.6079H8.64746V13.4507H13.4915V10.6079Z",
    fill: "url(#paint8_linear_2341_2149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2341_2149",
    x1: 22.8032,
    y1: 13.4752,
    x2: 22.7573,
    y2: 10.5662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2341_2149",
    x1: 20.2862,
    y1: 17.2462,
    x2: 25.2812,
    y2: 14.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2341_2149",
    x1: 2.79971,
    y1: 19.9132,
    x2: 7.63975,
    y2: 19.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2341_2149",
    x1: 8.65285,
    y1: 19.9132,
    x2: 13.4929,
    y2: 19.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2341_2149",
    x1: 14.5064,
    y1: 19.9132,
    x2: 19.3464,
    y2: 19.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2341_2149",
    x1: 20.3548,
    y1: 19.9132,
    x2: 25.1948,
    y2: 19.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2341_2149",
    x1: 14.3154,
    y1: 16.7372,
    x2: 19.54,
    y2: 15.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2341_2149",
    x1: 8.48058,
    y1: 15.025,
    x2: 13.6688,
    y2: 16.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2341_2149",
    x1: 9.05962,
    y1: 10.1661,
    x2: 13.0973,
    y2: 13.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.4d1b7cb8706eb2d04d6bb2c9743465cd.svg";
export { ForwardRef as ReactComponent };